// Reconstructed from the supplied production build; original component names were unavailable.
import { API_BASE_URL } from "../config.js";
const requestPasswordReset = async (a) => {
  const i = [
    API_BASE_URL + "/auth/forgot-password",
    API_BASE_URL + "/api/auth/forgot-password",
    API_BASE_URL + "/auth/forgot-password",
  ][0];
  console.log("Making request to:", i);
  const l = await fetch(i, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: a,
    }),
  });
  (console.log("Response status:", l.status),
    console.log("Response headers:", l.headers.get("content-type")));
  const c = l.headers.get("content-type");
  if (c && c.includes("text/html"))
    throw new Error(`API endpoint not found at ${i}. Please check your backend routes.`);
  if (!l.ok) {
    const m = await l.text();
    throw (console.log("Error response:", m), new Error(`HTTP ${l.status}: ${m}`));
  }
  return await l.json();
};
const resetPassword = async (a, n, i) => {
  const l = API_BASE_URL + "/auth/reset-password";
  console.log("Making request to:", l);
  const c = await fetch(l, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      userId: a,
      otp: n,
      newPassword: i,
    }),
  });
  console.log("Response status:", c.status);
  const u = c.headers.get("content-type");
  if (u && u.includes("text/html"))
    throw new Error(`API endpoint not found at ${l}. Please check your backend routes.`);
  if (!c.ok) {
    const f = await c.text();
    throw (console.log("Error response:", f), new Error(`HTTP ${c.status}: ${f}`));
  }
  return await c.json();
};
export { requestPasswordReset, resetPassword };
